import { Tabs } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface StableTabsContentGroupProps {
    children: ReactNode;
}

interface StableTabsContentProps {
    activeValue: string;
    value: string;
    children: ReactNode;
}

export const StableTabsContentGroup = ({ children }: StableTabsContentGroupProps) => (
    <Tabs.ContentGroup display='grid' gridTemplateColumns='minmax(0, 1fr)' alignItems='start'>
        {children}
    </Tabs.ContentGroup>
);

export const StableTabsContent = ({ activeValue, value, children }: StableTabsContentProps) => {
    const isActive = activeValue === value;

    return (
        <Tabs.Content
            value={value}
            hidden={false}
            aria-hidden={isActive ? undefined : true}
            inert={!isActive}
            gridArea='1 / 1'
            minW='0'
            visibility={isActive ? 'visible' : 'hidden'}
            pointerEvents={isActive ? 'auto' : 'none'}
        >
            {children}
        </Tabs.Content>
    );
};
